import angular from 'angular';
// TODO: https://graystep.atlassian.net/browse/GR-2153
import webSpinner from './csmBooks/webspinner-ajs/webspinner-ajs';

/** Main Books */
import books from './csmBooks/books';
import booksServices from './csmBooks/booksServices';
import booksDom from './csmBooks/booksDom';
/** Main Login */
import loginApp from './csmBooks/main/app';
/** Menu */
import menu from './csmBooks/menu/Menu';
/** Data */
import booksData from './csmBooks/data/BooksData';
/** Commonly used UI */
import addChangeSystemLoginDialog from './csmBooks/com/AddChangeSystemLoginDialog/AddChangeSystemLoginDialog';
import creditMemoDialog from './csmBooks/com/CreditMemoDialog/CreditMemoDialog';
import groupMembers from './csmBooks/com/groupMembers/groupMembers';
import limitedReceiptItemsDialog from './csmBooks/com/LimitedReceiptItemsDialog/LimitedReceiptItemsDialog';
import paymentDistributionDialog from './csmBooks/com/PaymentDistributionDialog/PaymentDistributionDialog';
import receiptsEntityInfoDialog from './csmBooks/com/ReceiptsEntityInfoDialog/ReceiptsEntityInfoDialog';
import returnItems from './csmBooks/com/returnItems/returnItems';
import voidEntryDialog from './csmBooks/com/VoidEntryDialog/VoidEntryDialog';
/************************************ Report Pages ************************************/
import accountTotalsReport from './csmBooks/reports/accountTotalsReport/accountTotalsReport';
import auditReport from './csmBooks/reports/auditReport/auditReport';
import chargesReport from './csmBooks/reports/chargesReport/chargesReport';
import checksReport from './csmBooks/reports/checksReport/checksReport';
import communitiesReport from './csmBooks/reports/communitiesReport/communitiesReport';
import consolidatedAcctsReport from './csmBooks/reports/consolidatedAcctsReport/consolidatedAcctsReport';
import creditMemoReport from './csmBooks/reports/creditMemoReport/creditMemoReport';
import dailyPostingReport from './csmBooks/reports/dailyPostingReport/dailyPostingReport';
import districtBankReconReport from './csmBooks/reports/districtBankReconReport/districtBankReconReport';
import finesReport from './csmBooks/reports/finesReport/finesReport';
import invoiceReport from './csmBooks/reports/invoiceReport/invoiceReport';
import itemOptionsReport from './csmBooks/reports/ItemOptionsReport/itemOptionsReport';
import itemSummaryReport from './csmBooks/reports/ItemSummaryReport/itemSummaryReport';
import journalEntryReport from './csmBooks/reports/journalEntryReport/journalEntryReport';
import paymentsReport from './csmBooks/reports/paymentsReport/paymentsReport';
import poApprovalList from './csmBooks/reports/poApprovalList/poApprovalList';
import purchaseOrderReport from './csmBooks/reports/purchaseOrderReport/purchaseOrderReport';
import receiptBatchReport from './csmBooks/reports/receiptBatchReport/receiptBatchReport';
import receivablesReport from './csmBooks/reports/receivablesReport/receivablesReport';
import recordsReport from './csmBooks/reports/recordsReport/recordsReport';
import studentReport from './csmBooks/reports/studentReport/studentReport';
/************************************ Tools Pages ************************************/
/** Bank Recon */
import bankRecon from './csmBooks/tools/BankRecon/BankRecon';
/** Bank Recon History */
import bankReconHistory from './csmBooks/tools/bankReconHistory/bankReconHistory';
/** Bulk Action */
import bulkActions from './csmBooks/tools/bulkActions/bulkActions';
/** Budgets */
import showBudget from './csmBooks/tools/budgets/showBudget';
/** Registration Product Forms */
import regProductForms from './csmBooks/tools/regProductForms/regProductForms';
/************************************ Admin Pages ************************************/
/** Account Admin */
import accountAdmin from './csmBooks/admin/accountAdmin/accountAdmin';
/** Entities Admin/Individuals */
import addChangeGroupDialog from './csmBooks/admin/entitiesAdmin/dialogs/AddChangeGroupDialog/AddChangeGroupDialog';
import groupsListDialog from './csmBooks/admin/entitiesAdmin/dialogs/GroupsListDialog/GroupsListDialog';
import namesListDialog from './csmBooks/admin/entitiesAdmin/dialogs/NamesListDialog/NamesListDialog';
import makeMemberDialog from './csmBooks/admin/entitiesAdmin/dialogs/MakeMemberDialog/MakeMemberDialog';
import entitiesAdmin from './csmBooks/admin/entitiesAdmin/entitiesAdmin';
import entityAdminListItem from './csmBooks/admin/entitiesAdmin/data/EntityAdminListItem';
import entitiesAdminApp from './csmBooks/admin/entitiesAdmin/app';
/** Events Admin */
import eventsAdmin from './csmBooks/admin/eventsAdmin/eventsAdmin';
import attendeeReportDialog from './csmBooks/admin/eventsAdmin/services/AttendeeReportDialog';
import events from './csmBooks/admin/eventsAdmin/services/Events';
/** Fundraisers */
import fundraisers from './csmBooks/admin/fundraisers/fundraisers';
/** Item Admin */
import addChangeItem from './csmBooks/com/AddChangeItem/AddChangeItem';
import itemAdmin from './csmBooks/admin/itemAdmin/ItemAdmin';
import addChangeTagDialog from './csmBooks/com/AddChangeTagDialog/AddChangeTagDialog';
import addChangeItemCategoryDialog from './csmBooks/com/AddChangeItemCategoryDialog/AddChangeItemCategoryDialog';
/** Missing Receipts Admin */
import missingReceiptsAdmin from './csmBooks/admin/MissingReceiptsAdmin/MissingReceiptsAdmin';
/** Store Admin */
import storeAdminApp from './csmBooks/admin/storeAdmin/App';
/** Tag Admin */
import tagAdmin from './csmBooks/admin/tagAdmin/tagAdmin';
/** Our Org */
import ourOrg from './csmBooks/admin/OurOrg/OurOrg';
/** RevTrak Admin */
import revTrakAdmin from './csmBooks/admin/revTrak/revTrakAdmin';
/** Store Account Management */
import storeAccountManagement from './csmBooks/admin/StoreAccountManagement/App';
/** Vendor Admin */
import vendorAdmin from './csmBooks/admin/vendorsAdmin/vendorsAdmin';
/************************************ Checks Pages ************************************/
/** Invoices */
import invoices from './csmBooks/checks/invoices/invoices';
/** Print Checks */
import printChecks from './csmBooks/checks/printChecks/printChecks';
/** Purchase Orders */
import purchaseOrders from './csmBooks/checks/purchaseOrders/purchaseOrders';
/** Write New Checks */
import writeChecks from './csmBooks/checks/WriteChecks/WriteChecks';
/************************************ Receipts Pages ************************************/
/** Deposit History */
import depositHistory from './csmBooks/receipts/depositHistory/depositHistory';
/** Make Deposit */
import makeDeposit from './csmBooks/receipts/MakeDeposit/MakeDeposit';
/** Return Receipts */
import returnReceipts from './csmBooks/receipts/returnReceipts/returnReceipts';
/** Write New Receipts */
import writeReceipts from './csmBooks/receipts/WriteReceipts/WriteReceipts';
/************************************ Ledger Pages ************************************/
import nsfChecks from './csmBooks/ledger/NSFChecks/nsfChecks';
import nsfChecksConfig from './csmBooks/ledger/NSFChecks/NSFChecksConfig';
/** Adjustments */
import adjustments from './csmBooks/Adjustments/Adjustments';
/** Initial Setup */
import initialSetup from './csmBooks/InitialSetup/App';

export default angular.module('CSMBooks', [
  webSpinner,
  /** Main Books */
  books,
  booksDom,
  booksServices,
  /** Main Login */
  loginApp,
  /** Menu */
  menu,
  /** Data */
  booksData,
  /** Commonly used UI */
  creditMemoDialog,
  groupMembers,
  addChangeSystemLoginDialog,
  limitedReceiptItemsDialog,
  paymentDistributionDialog,
  receiptsEntityInfoDialog,
  returnItems,
  voidEntryDialog,

  /************************************ Report Pages ************************************/
  accountTotalsReport,
  auditReport,
  chargesReport,
  checksReport,
  communitiesReport,
  consolidatedAcctsReport,
  creditMemoReport,
  dailyPostingReport,
  districtBankReconReport,
  finesReport,
  invoiceReport,
  itemOptionsReport,
  itemSummaryReport,
  journalEntryReport,
  paymentsReport,
  poApprovalList,
  purchaseOrderReport,
  receiptBatchReport,
  receivablesReport,
  recordsReport,
  studentReport,

  /************************************ Tools Pages ************************************/
  /** Bank Recon */
  bankRecon,
  /** Bank Recon History */
  bankReconHistory,
  /** Bulk Actions */
  bulkActions,
  /** Budgets */
  showBudget,
  /** Registration Product Forms */
  regProductForms,
  /************************************ Admin Pages ************************************/
  /** Account Admin */
  accountAdmin,
  /** Entities Admin/Individuals */
  addChangeGroupDialog,
  groupsListDialog,
  namesListDialog,
  makeMemberDialog,
  entitiesAdmin,
  entityAdminListItem,
  entitiesAdminApp,
  /** Events Admin */
  eventsAdmin,
  attendeeReportDialog,
  events,
  /** Fundraiser */
  fundraisers,
  /** Item Admin */
  addChangeItem,
  addChangeTagDialog,
  addChangeItemCategoryDialog,
  itemAdmin,
  /** Missing Receipts Admin */
  missingReceiptsAdmin,
  /** Store Admin */
  storeAdminApp,
  /** Tag Admin */
  tagAdmin,
  /** Our Org */
  ourOrg,
  /** RevTrak Admin */
  revTrakAdmin,
  /** Store Account Management */
  storeAccountManagement,
  /** Vendor Admin */
  vendorAdmin,
  /************************************ Checks Pages ************************************/
  /** Invoices */
  invoices,
  /** Print Checks */
  printChecks,
  /** Purchase Orders */
  purchaseOrders,
  /** Write New Checks */
  writeChecks,
  /************************************ Receipts Pages ************************************/
  /** Deposit History */
  depositHistory,
  /** Make Deposit */
  makeDeposit,
  /** Return Receipts */
  returnReceipts,
  /** Write New Receipts */
  writeReceipts,
  /************************************ Ledger Pages ************************************/
  nsfChecks,
  nsfChecksConfig,
  /************************************ Stand Alone Pages ************************************/
  /** Adjustments */
  adjustments,
  /** Initial Setup */
  initialSetup
]).name;

// angular.bootstrap(document, ['CSMBooks'], { strictDi: true });
